import { render } from "./FormContatti.vue?vue&type=template&id=0b7a9be2"
import script from "./FormContatti.vue?vue&type=script&lang=js"
export * from "./FormContatti.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__